export var QuillToolbarFormatType;
(function (QuillToolbarFormatType) {
    QuillToolbarFormatType["SIZE"] = "size";
    QuillToolbarFormatType["BOLD"] = "bold";
    QuillToolbarFormatType["ITALIC"] = "italic";
    QuillToolbarFormatType["UNDERLINE"] = "underline";
    QuillToolbarFormatType["DATE_EMBED"] = "dateEmbed";
    QuillToolbarFormatType["LINK"] = "link";
})(QuillToolbarFormatType || (QuillToolbarFormatType = {}));
export const BASE_TOOLBAR_FORMATS = [
    QuillToolbarFormatType.BOLD,
    QuillToolbarFormatType.ITALIC,
    QuillToolbarFormatType.UNDERLINE,
];
